export default function MySQL_STRCMP() {
  return (
    <div>
      <h2>MySQL_STRCMP</h2>    </div>
  );
}